import React from "react";
import Typography from '@mui/material/Typography';
var Config = require('../config.json')


const Footer = () => {
  return (
    <div className="footer">   
	    <Typography variant="caption" gutterBottom sx={{ display: 'block' }}>
        {"Copyright © "}{Config.title} {new Date().getFullYear()}
      </Typography>
    </div>
  );
};
export default Footer;